import { useFormContext } from "react-hook-form";
import { ActivityRegistrationNumberInput } from "@shared-kernel/primary/shared/activity-registration-number-input/activity-registration-number-input";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { Input } from "@shared-kernel/primary/shared/shadcn/ui/input";
import { Label } from "@shared-kernel/primary/shared/shadcn/ui/label";
import { AddressBlock } from "@shared-kernel/primary/shared/address-autocomplete/address-block";
import { SiretAutocompleteField } from "@shared-kernel/primary/shared/siret-autocomplete/siret-autocomplete-field";
import { EUROPEAN_COUNTRIES } from "@shared-kernel/domain/types/supported-country";
import type { ProviderOnboardingFormInputs } from "../form-validation/full-form.schema";
import { IbanInput } from "@shared-kernel/primary/shared/iban-input/iban-input";

export const FormStep = () => {
  const { control } = useFormContext<ProviderOnboardingFormInputs>();

  return (
    <div className="space-y-4">
      <AddressBlock
        fields={{
          postalAddress: "postalAddress",
          addressComplement: "addressComplement",
          country: "country",
        }}
        addressLabel="Adresse de l'organisation"
        countries={EUROPEAN_COUNTRIES}
      />
      <SiretAutocompleteField siretFieldName="siret" countryFieldName="country" nameFieldName="name" />
      <FormField
        control={control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nom de l&apos;organisation</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="activityRegistrationNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Numéro de déclaration d&apos;activité (optionnel)</FormLabel>
            <FormControl>
              <ActivityRegistrationNumberInput placeholder="11 chiffres" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <div className="space-y-2">
        <Label>Représentant légal</Label>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <FormField
            control={control}
            name="legalRepresentativeFirstName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Prénom</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name="legalRepresentativeLastName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Nom</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
      <FormField
        control={control}
        name="iban"
        render={({ field }) => (
          <FormItem>
            <FormLabel>IBAN (zone Euro)</FormLabel>
            <FormControl>
              <IbanInput placeholder="Exemple : FR76 4061 8803 0000 0408 3645 139" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
